<template>
  <div class="my_review_record">
    <van-tabs class="" v-model="active" color="#f5222d">
      <record-tab title="待审核" :review_status="1" />
      <record-tab title="已通过" :review_status="2" />
      <record-tab title="未通过" :review_status="3" />
    </van-tabs>
  </div>
</template>

<script>
import { Cell, Tab, Tabs } from 'vant'
import RecordTab from './components/MyRecordTab'

export default {
  name: 'MyReviewRecord',
  components: {
    [Cell.name]: Cell,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    RecordTab
  },
  data () {
    return {
      active: 0
    }
  },
  created () {
    let active = parseInt(this.$route.hash.substring(1))
    this.active = isNaN(active) ? 0 : active
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
</style>
